import React from 'react';
import { Link } from 'react-router-dom';
import { Code2, Mail, MapPin } from 'lucide-react';
import { footerData } from '../../data/mock';

export const Footer = () => {
  return (
    <footer className="bg-stone-900 border-t border-stone-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2.5 mb-5">
              <div className="w-8 h-8 rounded-lg bg-amber-500 flex items-center justify-center">
                <Code2 className="w-4 h-4 text-white" />
              </div>
              <span className="text-lg font-bold text-stone-100 tracking-tight">
                {footerData.brand}
              </span>
            </Link>
            <p className="text-sm text-stone-400 leading-relaxed max-w-sm mb-6">
              {footerData.tagline}
            </p>
            <div className="space-y-2.5">
              <a
                href={`mailto:${footerData.contact.email}`}
                className="flex items-center gap-2.5 text-sm text-stone-400 hover:text-amber-400 transition-colors duration-200"
              >
                <Mail className="w-4 h-4" />
                {footerData.contact.email}
              </a>
              <div className="flex items-center gap-2.5 text-sm text-stone-500">
                <MapPin className="w-4 h-4" />
                {footerData.contact.address}
              </div>
            </div>
          </div>

          {/* Link sections */}
          {footerData.sections.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-stone-200 mb-4 tracking-wide">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    {link.href.startsWith('/') ? (
                      <Link
                        to={link.href}
                        className="text-sm text-stone-400 hover:text-amber-400 transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    ) : link.href.startsWith('mailto:') ? (
                      <a
                        href={link.href}
                        className="text-sm text-stone-400 hover:text-amber-400 transition-colors duration-200"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <a
                        href={link.href}
                        className="text-sm text-stone-400 hover:text-amber-400 transition-colors duration-200"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-stone-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-stone-500">
              &copy; {new Date().getFullYear()} {footerData.brand}. All rights
              reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link
                to="/privacy-policy"
                className="text-xs text-stone-500 hover:text-stone-300 transition-colors duration-200"
              >
                Privacy
              </Link>
              <Link
                to="/terms-of-service"
                className="text-xs text-stone-500 hover:text-stone-300 transition-colors duration-200"
              >
                Terms
              </Link>
              <Link
                to="/cookie-policy"
                className="text-xs text-stone-500 hover:text-stone-300 transition-colors duration-200"
              >
                Cookies
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
